import { render, staticRenderFns } from "./SortMenu.vue?vue&type=template&id=22d16f92&scoped=true&"
import script from "./SortMenu.vue?vue&type=script&lang=js&"
export * from "./SortMenu.vue?vue&type=script&lang=js&"
import style0 from "./SortMenu.vue?vue&type=style&index=0&id=22d16f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d16f92",
  null
  
)

export default component.exports